import escape from 'escape-string-regexp'

export default (query = '', tags = []) => {
  let string = query

  return tags
    .sort((a, b) => b.length - a.length)
    .reduce((tokens, tag) => {
      const regex = new RegExp('(^| )' + escape(tag) + '( |$)', 'i')
      if (string.match(regex)) {
        string = string.replace(regex, ' ')
        return [...tokens, tag]
      }
      return tokens
    }, [])
    .concat(string.split(' ').filter(s => s))
}



// WEBPACK FOOTER //
// ./src/utils/tokenize.js